import { getCurrentInstance } from 'vue'
import { getAllConfig } from '@pc-fx-framework/utils/config'

import type { InstallOptions } from '@pc-fx-framework/utils/config'

export function useGlobalConfig(): InstallOptions {
  const vm: any = getCurrentInstance()
  if ('$FX' in vm.proxy) {
    return vm.proxy.$FX
  }
  return getAllConfig()
}
